export default "__VITE_ASSET__06eaeb0f__"